import type { JSX } from "react";

import { useAnnouncerStore } from "@/stores/announcer-store";

/**
 * Visually hidden polite live region. New-mail and status announcements are
 * pushed here so screen-reader users learn about background changes.
 */
export function LiveAnnouncer(): JSX.Element {
  const message = useAnnouncerStore((state) => state.message);
  const seq = useAnnouncerStore((state) => state.seq);
  return (
    <p key={seq} role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </p>
  );
}
